import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import arrowLeft from "../assets/images/navbar/arrow-left.png";
import logo from "../assets/images/logo.png";
import blackStar from "../assets/images/icons/blackstar.png";
import filledStar from "../assets/images/icons/star.png";
import { feedbackService } from "../services";

const RateUs = () => {
  const navigate = useNavigate();
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (rating === 0) {
      toast.error("Please select a star rating before submitting.");
      return;
    }

    setLoading(true);
    try {
      await feedbackService.submitAppRating({
        rating,
        feedback: feedback.trim() || undefined,
      });
    } catch {
      // Persist locally if API is unavailable
      const existing = JSON.parse(
        localStorage.getItem("duddusAppRatings") || "[]"
      );
      existing.push({
        rating,
        feedback: feedback.trim(),
        createdAt: new Date().toISOString(),
      });
      localStorage.setItem("duddusAppRatings", JSON.stringify(existing));
    } finally {
      setLoading(false);
    }

    setSubmitted(true);
    toast.success("Thanks for your feedback!");
  };

  return (
    <div className="bg-white dark:bg-gray-900 min-h-screen transition-colors duration-300 mt-[7.5rem] md:mt-[72px]">
      <div className="max-w-lg mx-auto px-4 py-6">
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 flex items-center justify-center"
          >
            <img src={arrowLeft} alt="back" className="w-6 h-6 dark:invert" />
          </button>
          <h1 className="text-[#050505] dark:text-white font-urbanist text-[22px] font-semibold">
            Rate Us
          </h1>
        </div>

        <div className="rounded-[16px] border dark:border-gray-700 bg-white dark:bg-gray-800 p-8 flex flex-col items-center text-center">
          <img src={logo} alt="Duddus" className="h-20 w-20 object-contain mb-4" />
          <h2 className="text-[#050505] dark:text-white font-urbanist text-[22px] font-semibold mb-2">
            Enjoying Dudos?
          </h2>
          <p className="text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[14px] mb-6">
            Tap a star to rate us and share your experience.
          </p>

          <div className="flex gap-2 mb-6">
            {Array(5)
              .fill(0)
              .map((_, index) => (
                <img
                  key={index}
                  src={index < rating ? filledStar : blackStar}
                  alt={index < rating ? "filled star" : "empty star"}
                  className="h-9 w-9 cursor-pointer"
                  onClick={() => !submitted && setRating(index + 1)}
                />
              ))}
          </div>

          {!submitted ? (
            <>
              <textarea
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Tell us more (optional)"
                className="w-full min-h-[100px] p-3 rounded-[12px] border dark:border-gray-600 bg-[#F5F5F5] dark:bg-gray-700 text-[#050505] dark:text-white font-urbanist outline-none mb-4"
              />
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="w-full py-4 bg-[#7402A7] dark:bg-purple-600 text-white rounded-[150px] font-urbanist text-[18px] font-semibold hover:bg-[#5f0289] transition-colors disabled:opacity-60"
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </>
          ) : (
            <p className="text-[#02A72B] dark:text-green-400 font-urbanist text-[16px] font-medium">
              Thank you for rating Dudos!
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RateUs;
